import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse } from '@fortawesome/pro-light-svg-icons'

import {
  Box, HoverHintWrapper, StatusBadge, Text,
} from '@domain-group/suit-theme'

import usePublicationBookingItems from '@hooks/usePublicationBookingItems'
import useSelector from '@hooks/useSelector'

import type { PublicationBookingModel } from '@models/types'

const CampaignsBadge = (props: { publicationBooking: PublicationBookingModel }) => {
  const { publicationBooking } = props

  const publicationBookingItemsPayload = usePublicationBookingItems({
    filters: { publication_booking_id: publicationBooking?.id },
  })
  const {
    filteredPublicationBookingItems,
    filteredPublicationBookingItemsCount,
    hasFilteredPublicationBookingItems,
  } = publicationBookingItemsPayload

  const campaigns = useSelector(reduxState => reduxState.entities.campaigns)

  return (
    <HoverHintWrapper
      boxProps={{ marginLeft: 'large' }}
      hintComponent={hasFilteredPublicationBookingItems && (
      <HoverHintWrapper.Hint>
        <Box flexDirection="column">
          {Object.values(filteredPublicationBookingItems).map((bookingItem) => {
            // @ts-expect-error TS2339
            const campaign = campaigns[bookingItem.campaign] || {}

            return <span key={bookingItem.id}>{`${campaign.address}, ${campaign.suburb_name}`}</span>
          })}
        </Box>
      </HoverHintWrapper.Hint>
      )}
    >
      <StatusBadge icon={<Text>{filteredPublicationBookingItemsCount} <FontAwesomeIcon icon={faHouse} /></Text>} />
    </HoverHintWrapper>
  )
}

export default CampaignsBadge
